export default __webpack_public_path__ + "static/media/WorkExpAutomation-Icon.c17f5e3f.svg";